(function($, window, document) {
	
	// Page Functions
	
	var canBeLoaded = true,
        headerHeight;

	window.PageFunctions = {
		
		setup: function() {
			this.shrinkHeaderOnScroll();
			this.scrollToAnchorLinks();
            this.accordions();
            this.mobileMenu();
            this.openContactForm();
		},     

        openContactForm: function() {
            $(document).on('click', 'a[href="#contact"]', lity);
        },

        mobileMenu: function() {
            $(".menu-trigger-container").on("click", function(e) {
                  e.preventDefault();
                  if ($('body').hasClass("menu-open")) {
                      $('body').removeClass("menu-open");
                  } else {
                      $('body').addClass("menu-open");
                  }
              });

            $(".menus.mobile .main-menu--has_mega_nav > a").on("click", function(e) {
                e.preventDefault();
                $(this).next().slideToggle();
                $(this).parent().toggleClass('mega-nav-item-open')
            });

            // deal with dropdowns
            $('.menus.mobile .has-sub > a').each(function(e) {

                var parent = $(this).parent(),
                    sub_menu = $(this).next(),
                    link = $(this).attr('href');

                $(this).on('click', function(e) {
                    e.preventDefault();
                    sub_menu.slideToggle();
                    $(this).toggleClass('menu-item-open');
                });

                sub_menu.prepend('<li><a href="' + link + '">Overview</a></li>');

            });

        },


		/**
         * Scroll to anchor links
         */
        scrollToAnchorLinks: function() {

          $("main.main a[href^='#']:not(.noscroll):not([data-lity]):not([href='#contact'])").on("click", function(e) {
              e.preventDefault();
              href = $(this).attr("href");

              if (href.length > 1) {
                 window.PageFunctions.scrollToTopOfDivWithOffset(href);
              }
          });

        },

        /**
         *  Add shrink class to header on scroll
         */
        shrinkHeaderOnScroll: function() {
            var $threshold = 50,
                $window = $(window),
                $height = $window.scrollTop();

            $window.scroll(function() {
                $scroll_position = $window.scrollTop();
                if ($scroll_position > $threshold) {
                    $("body").addClass("shrink");
                } else {
                    $("body").removeClass("shrink");
                }
            });

            // if the scroll position is greater than 0, add the shrink class. This handles a refresh in the middle of the page.
            if ($height > 0) {
                $("body").addClass("shrink");
            }

        },
        /**
         * Accordions
         */
        accordions: function() {
            $('.js--accordion-trigger').on('click', function(e) {
                e.preventDefault();
                $(this).parent().toggleClass('open');
                $(this).next().slideToggle();

                if ( $(this).hasClass('g--sidebar--category_title')  ) {
                    $(this).next().next().toggle();
                }

            });
        }


	};

})(window.jQuery, window, document); // End of jQuery wrapper



